import React from 'react'
import { keyframes, styled } from 'styled-components'

import {
  GECKO_POWER_TABLE_FLAT_DENSITY,
  GECKO_POWER_TABLE_ROW_BG,
} from './TableStyles'

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`

const SkeletonRow = styled.tr`
  background-color: ${GECKO_POWER_TABLE_ROW_BG};

  td {
    border-bottom: 1px solid var(--border) !important;
  }
`

const SkeletonCell = styled.td`
  padding: var(
    --table-cell-padding,
    ${GECKO_POWER_TABLE_FLAT_DENSITY.cellPadding}
  );
  box-sizing: border-box;
  height: var(--table-row-height, ${GECKO_POWER_TABLE_FLAT_DENSITY.rowHeight});
  min-height: var(
    --table-row-height,
    ${GECKO_POWER_TABLE_FLAT_DENSITY.rowHeight}
  );
  border-style: hidden !important;
`

const ShimmerBar = styled.div<{ $width?: string }>`
  height: 0.75rem;
  width: ${({ $width }) => $width ?? '70%'};
  border-radius: 0.25rem;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.forecast.cardGroupBackground} 25%,
    ${({ theme }) => theme.forecast.hoverButton} 50%,
    ${({ theme }) => theme.forecast.cardGroupBackground} 75%
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
`

/** Each column gets a fixed width; columns cycle through these values. */
const COLUMN_WIDTHS = ['70%', '55%', '80%', '45%', '65%', '50%', '75%', '60%']

interface TableSkeletonRowsProps {
  columnCount: number
  rowCount?: number
}

/**
 * Renders placeholder rows with shimmer bars that preserve the table structure
 * while data is loading. Every row in a given column shares the same bar width,
 * mimicking how real table data fills each column consistently.
 */
export const TableSkeletonRows: React.FC<TableSkeletonRowsProps> = ({
  columnCount,
  rowCount = 16,
}) => {
  return (
    <>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <SkeletonRow key={rowIndex}>
          {Array.from({ length: columnCount }, (_, colIndex) => (
            <SkeletonCell key={colIndex}>
              <ShimmerBar
                $width={COLUMN_WIDTHS[colIndex % COLUMN_WIDTHS.length]}
              />
            </SkeletonCell>
          ))}
        </SkeletonRow>
      ))}
    </>
  )
}
